import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { KeyboardModule } from '@qtek/libs/keyboard';
import { TranslationCoreModule } from '@qtek/libs/translation-core';
import {
  ChatComponent,
  KeyboardSwitchComponent,
  ThemeSwitchComponent,
  UiTourDirective,
} from '@qtek/libs/ui';
import { WsErrorHandlerModule } from '@qtek/libs/ws-error-handler';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { HealthcheckCoreModule } from '@qtek/libs/healthcheck-core';
import {
  AuthEffects,
  AuthFeature,
  DocumentsEffects,
  DocumentsFeature,
  MenuEffects,
  MenuFeature,
  NewRelationsEffects,
  NewRelationsFeature,
  TagManagerEffects,
  TagManagerFeature,
  TasksEffects,
  TasksFeature,
  WizardEffects,
  wizardFeature,
} from '@qtek/libs/store';
import * as fromComponent from './components';
import { AvatarMenuComponent } from './components';
import * as fromGuards from './guards';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    KeyboardModule,
    WsErrorHandlerModule,
    UiTourDirective,
    TranslationCoreModule,
    MatBadgeModule,
    MatToolbarModule,
    MatSidenavModule,
    MatMenuModule,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    MatTooltipModule,
    MatCardModule,
    MatListModule,
    KeyboardSwitchComponent,
    ThemeSwitchComponent,
    HealthcheckCoreModule,
    ChatComponent,
    ...fromComponent.standaloneComponents,
  ],
  declarations: [...fromComponent.components],
  providers: [
    ...fromGuards.guards,
    provideState(AuthFeature),
    provideState(wizardFeature),
    provideState(MenuFeature),
    provideState(DocumentsFeature),
    provideState(TasksFeature),
    provideState(TagManagerFeature),
    provideState(NewRelationsFeature),
    provideEffects(
      AuthEffects,
      WizardEffects,
      MenuEffects,
      DocumentsEffects,
      TasksEffects,
      TagManagerEffects,
      NewRelationsEffects
    ),
  ],
  exports: [AvatarMenuComponent],
})
export class LayoutModule {}
